/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
/** TODO FILE */
import React, { useRef } from 'react';
import Arrow from 'src/assets/arrow-left-black.svg';

import { CommonDropdown, CommonInput, DatePicker, Label, Loader, RegularButton } from 'pg-ui-library';
import { useTranslation } from 'react-i18next';

import { useFormik } from 'formik';
import fallbackImageUrl from 'src/assets/empty_photo_benefit.jpg';
import BenefitsService from 'src/services/benefits.service';
import { useQuery } from '@tanstack/react-query';
import {
  Container,
  ItemContainer,
  ArrowBack,
  NavTextLink,
  ItemContainerHeader,
  PageTitle,
  HeaderLeftItems,
  HeaderRightItems,
  HeaderLeftFirstItem,
  HeaderLeftSecondItem,
  InputLabel,
  FileUploadWrapper,
  Input,
  FileUploadWrapperRemove,
  TrashIcon,
  FileInputContainer,
  GalleryWrapper,
  GalleryHeader,
  GalleryScrollableContainer,
  EmptyGalleryContainer,
  FallbackImg,
  GalleryCardImg,
} from './styles';

export const BenefitRules: React.FC = () => {
  const { t } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const formik = useFormik({
    initialValues: {
      name: '',
      files: [],
      fileName: '',
      imgKey: '',
    },
    onSubmit: values => {
      // console.table(values);
    },
  });

  const { isFetching, data: imgGallery } = useQuery(['benefits/images'], async () => {
    const result = await BenefitsService.getBenefitsImgGallery();
    return result;
  });

  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    // eslint-disable-next-line no-param-reassign
    event.currentTarget.src = fallbackImageUrl;
  };

  return (
    <Container>
      <ItemContainerHeader>
        <HeaderLeftItems>
          <HeaderLeftFirstItem>
            <NavTextLink to="/benefits/version-management">
              <ArrowBack src={Arrow} />
            </NavTextLink>
            <PageTitle>Benefit Edit</PageTitle>
          </HeaderLeftFirstItem>
          <HeaderLeftSecondItem />
        </HeaderLeftItems>
        <HeaderRightItems>
          <RegularButton type="button">Premium & Payout Config</RegularButton>
          <RegularButton type="submit" onClick={() => formik.handleSubmit()}>
            {t('global.form.save')}
          </RegularButton>
        </HeaderRightItems>
      </ItemContainerHeader>
      <ItemContainer>
        <CommonInput
          style={{ width: '550px' }}
          name="name"
          label="Name"
          value={formik.values.name}
          onChange={formik.handleChange}
        />
        <FileInputContainer>
          <InputLabel>File</InputLabel>

          <FileUploadWrapper
            style={{
              background: '#F3F4F8',
              display: 'flex',
              alignSelf: 'center',
              borderRadius: '10px',
            }}
          >
            <Input
              style={{ width: '550px' }}
              data-cy="benefit-rules-file-name"
              id="fileName"
              name="fileName"
              placeholder="Drag and drop or click to upload files"
              value={formik.values.fileName}
              disabled
            />
            <FileUploadWrapperRemove
              onClick={() => {
                formik.setFieldValue('files', null);
                formik.setFieldValue('fileName', '');
                if (fileInputRef.current) {
                  fileInputRef.current.value = '';
                }
              }}
            >
              <TrashIcon />
            </FileUploadWrapperRemove>
          </FileUploadWrapper>
          <Input
            ref={fileInputRef}
            style={{
              width: '80%',
              zIndex: 1,
              marginTop: '-45px',
              cursor: 'pointer',
              opacity: '0',
            }}
            data-cy="benefit-rules-file"
            type="file"
            id="files"
            name="files"
            accept=".pdf"
            multiple
            placeholder="Drag and drop or click to upload a file"
            onChange={e => {
              const { files } = e.target;
              let filesName = '';
              if (files) {
                formik.setFieldValue('files', files);

                // eslint-disable-next-line no-plusplus
                for (let index = 0; index < files.length; index++) {
                  const file = files.item(index);
                  if (file) {
                    filesName = [filesName, file.name].join(' ');
                  }
                }
                formik.setFieldValue('fileName', filesName);
              } else {
                formik.setFieldValue('files', null);
                formik.setFieldValue('fileName', '');
              }
            }}
          />
        </FileInputContainer>
      </ItemContainer>
      <ItemContainer>
        <div style={{ display: 'flex', gap: '30px' }}>
          <div>
            <Label>Additional amount for smokers:</Label>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Label style={{ margin: 0 }}>Coverage Amount/ </Label>
              <input type="number" />
              <Label style={{ margin: 0 }}> x(Based on range)</Label>
            </div>
          </div>

          <div>
            <Label>Use employee age for spouse premiums</Label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Label style={{ margin: 0 }}>Yes</Label>
              <input type="radio" id="disclaimer" name="disclaimer" onChange={formik.handleChange} value="yes" />
              <Label style={{ margin: 0 }}>No</Label>
              <input type="radio" id="disclaimer" name="disclaimer" onChange={formik.handleChange} checked value="no" />
            </div>
          </div>
        </div>
      </ItemContainer>
      <ItemContainer>
        <div style={{ display: 'flex', gap: '30px' }}>
          <div>
            <Label>Date used when looking for age:</Label>
            <div style={{ display: 'flex' }}>
              <CommonDropdown
                label="Open Enrollment"
                id="openEnrollment"
                name="openEnrollment"
                setValue={(value: string) => {}}
                value=""
                options={[]}
                wrapperStyle={{ width: '100%' }}
                selectStyle={{
                  maxWidth: 'none',
                  width: '100%',
                  backgroundColor: '#ffffff',
                  height: '35px',
                }}
              />
              <DatePicker
                id="openEnrollmentDate"
                name="openEnrollmentDate"
                onChange={date => {}}
                label="Date"
                placeholderText="MM/DD/YY"
              />
            </div>
          </div>
          <div>
            <div style={{ display: 'flex' }}>
              <CommonDropdown
                label="New Hire & QLE"
                id="openEnrollment"
                name="openEnrollment"
                setValue={(value: string) => {}}
                value=""
                options={[]}
                wrapperStyle={{ width: '100%' }}
                selectStyle={{
                  maxWidth: 'none',
                  width: '100%',
                  backgroundColor: '#ffffff',
                  height: '35px',
                }}
              />
              <DatePicker
                id="newHireDate"
                name="newHireDate"
                onChange={date => {}}
                label="Date"
                placeholderText="MM/DD/YY"
              />
            </div>
          </div>
        </div>
      </ItemContainer>
      <ItemContainer>
        <GalleryWrapper>
          <GalleryHeader>{t('benefits.editModal.gallery.title')}</GalleryHeader>
          <GalleryScrollableContainer>
            {isFetching ? (
              <EmptyGalleryContainer>
                <Loader />
              </EmptyGalleryContainer>
            ) : (
              imgGallery?.map(galleryImg => (
                <GalleryCardImg
                  key={galleryImg.key}
                  onClick={() => formik.setFieldValue('imgKey', galleryImg.url)}
                  selected={formik.values.imgKey === galleryImg.url}
                >
                  <FallbackImg src={galleryImg.url} alt="Fallback Image" onError={handleImageError} />
                </GalleryCardImg>
              ))
            )}
            {imgGallery === undefined && !isFetching && (
              <EmptyGalleryContainer>
                <p>{t('benefits.editModal.gallery.empty')}</p>
              </EmptyGalleryContainer>
            )}
          </GalleryScrollableContainer>
        </GalleryWrapper>
      </ItemContainer>
    </Container>
  );
};
